import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import { getAssessment, getTask } from "../services/APIClient";

const DYSLEXIA_SCREENER_ID = "5a680b62-c6f8-4379-8ff3-235ef4273403";

function DyslexiaScreenerSession() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const studentId = searchParams.get("studentId") || null;
  const studentName = searchParams.get("name") || null;

  console.log("DyslexiaScreenerSession URL params:", { studentId, studentName });

  const [assessorName, setAssessorName] = useState("");
  const [assessorEmail, setAssessorEmail] = useState("");

  const [assessmentInstanceId, setAssessmentInstanceId] = useState(null);
  const [assessmentId, setAssessmentId] = useState(null);
  const [firstTask, setFirstTask] = useState(null);
  const [taskIndex, setTaskIndex] = useState(null);
  const [numTasks, setNumTasks] = useState(null);
  const [loadingAssessment, setLoadingAssessment] = useState(false);

  useEffect(() => {
    if (!studentId) return;

    setLoadingAssessment(true);

    getAssessment(studentId)
      .then((assessments) => {
        console.log("getAssessment response:", assessments);

        const pending = (assessments || []).find(
          (a) => a.assessmentid === DYSLEXIA_SCREENER_ID && !a.completed
        );
        console.log("Pending assessment:", pending);

        if (!pending) {
          setLoadingAssessment(false);
          return;
        }

        setAssessmentInstanceId(pending.id);
        setAssessmentId(pending.assessmentid);

        return getTask(studentId, pending.id).then((taskData) => {
          console.log("getTask response:", taskData);

          setFirstTask(taskData);
          setTaskIndex(taskData?.index ?? 1);
          setNumTasks(taskData?.numTasks ?? taskData?.total ?? null);
          setLoadingAssessment(false);
        });
      })
      .catch((err) => {
        console.error("Error loading assessment for screener session:", err);
        setLoadingAssessment(false);
      });
  }, [studentId]);

  const handleStartScreener = () => {
    sessionStorage.setItem("assessorName", assessorName);
    sessionStorage.setItem("assessorEmail", assessorEmail);

    navigate("/dyslexiascreenerform", {
      state: {
        studentId,
        studentName,
        assessorName,
        assessorEmail,
        assessmentInstanceId,
        assessmentId,
        task: firstTask,
        taskIndex,
        numTasks,
      },
    });
  };

  return (
    <Container fluid className="vh-100 blue-background d-flex align-items-center justify-content-center">
      <Row className="w-100 justify-content-center">
        <Col md={7} lg={5}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "40px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
          >
            {/* Header */}
            <div className="text-center" style={{ marginBottom: "24px" }}>
              <img
                src="/assets/imgs/Alpaca-logo-white-outline.png"
                alt="Alpaca Logo"
                style={{ width: "56px", marginBottom: "12px" }}
              />
              <h3 style={{ color: "#333", marginBottom: "2px" }}>Dyslexia Screener</h3>
              <p style={{ color: "#888", margin: 0 }}>Pre-Screener Setup</p>
            </div>

            <hr style={{ borderColor: "#eee", marginBottom: "24px" }} />

            {/* Student name banner */}
            <div
              style={{
                background: "#EAF4FB",
                borderLeft: "4px solid #2980B9",
                padding: "12px 16px",
                borderRadius: "4px",
                marginBottom: "24px",
              }}
            >
              <h5 style={{ color: "#2980B9", margin: 0 }}>
                Student: {studentName || "Unknown"}
              </h5>
            </div>

            {/* Assessor Name */}
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "600" }}>Assessor Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={assessorName}
                onChange={(e) => setAssessorName(e.target.value)}
              />
            </Form.Group>

            {/* Assessor Email */}
            <Form.Group className="mb-4">
              <Form.Label style={{ fontWeight: "600" }}>Assessor Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={assessorEmail}
                onChange={(e) => setAssessorEmail(e.target.value)}
              />
            </Form.Group>

            <div className="text-center">
              <button
                className="green-button"
                onClick={handleStartScreener}
                disabled={!assessorName || !assessorEmail || loadingAssessment}
                style={{
                  width: "60%",
                  padding: "12px 0",
                  fontSize: "1rem",
                  fontWeight: "600",
                  opacity: assessorName && assessorEmail && !loadingAssessment ? 1 : 0.5,
                  cursor: assessorName && assessorEmail && !loadingAssessment ? "pointer" : "not-allowed",
                }}
              >
                START Screener
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default DyslexiaScreenerSession;
